import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
import BackButton from '../components/BackButton';
import { useLanguage } from '../contexts/LanguageContext';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useLanguage();

  const faqs = [
    {
      question: t('faq.howItWorks.question'),
      answer: t('faq.howItWorks.answer')
    },
    {
      question: t('faq.isFree.question'),
      answer: t('faq.isFree.answer')
    },
    {
      question: t('faq.joinDinner.question'),
      answer: t('faq.joinDinner.answer')
    },
    {
      question: t('faq.blindDates.question'),
      answer: t('faq.blindDates.answer')
    },
    {
      question: t('faq.createEvent.question'),
      answer: t('faq.createEvent.answer')
    },
    {
      question: t('faq.privacy.question'),
      answer: t('faq.privacy.answer')
    },
    {
      question: t('faq.cancellation.question'),
      answer: t('faq.cancellation.answer')
    },
    {
      question: t('faq.becomePartner.question'),
      answer: t('faq.becomePartner.answer')
    },
    {
      question: t('faq.drinkingNights.question'),
      answer: t('faq.drinkingNights.answer')
    },
    {
      question: t('faq.safety.question'),
      answer: t('faq.safety.answer')
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center space-x-4 mb-8">
        <BackButton />
        <h1 className="text-3xl font-bold text-gray-900">{t('faq.title')}</h1>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div 
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition"
            >
              <div className="flex items-center space-x-3">
                <HelpCircle className="h-5 w-5 text-orange-500 flex-shrink-0" />
                <span className="font-medium text-gray-900">{faq.question}</span>
              </div>
              {openIndex === index ? (
                <ChevronUp className="h-5 w-5 text-gray-400" />
              ) : (
                <ChevronDown className="h-5 w-5 text-gray-400" />
              )}
            </button>
            {openIndex === index && (
              <div className="px-6 py-4 bg-orange-50 border-t border-orange-100">
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;